import { createFileRoute, notFound } from "@tanstack/react-router";

import { getAcademyHub } from "@/content/academy";
import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import AcademyHubPage from "./-components/AcademyHubPage";
import { NotFoundPage } from "@/components/landing/LandingNotFound";

/**
 * A splat, because the academy's hubs nest, `/academy/scraping` and
 * `/academy/scraping/languages/python` are both hubs, and only the CMS knows
 * which paths exist. `/academy` itself is a 404 on the published site, and the
 * empty splat is what reproduces that.
 */
export const Route = createFileRoute("/academy/$")({
  loader: async ({ params }) => {
    const hub = await getAcademyHub({
      data: `/academy/${params._splat ?? ""}`,
    });
    if (!hub) {
      throw notFound();
    }
    return hub;
  },
  headers: ({ loaderData }) => ({
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  }),
  component: AcademyHubRoute,
  notFoundComponent: NotFoundPage,
});

function AcademyHubRoute() {
  return <AcademyHubPage hub={Route.useLoaderData()} />;
}
